import React from 'react';

const PageUnderDevelopment = () => {
  const styles = {
    wrapper: {
      height: '100vh',
      backgroundColor: '#f5f7fa',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      fontFamily: 'Segoe UI, sans-serif',
      color: '#444',
      padding: '20px',
    },
    icon: {
      fontSize: '5rem',
      marginBottom: '20px',
    },
    heading: {
      fontSize: '2.2rem',
      marginBottom: '10px',
    },
    paragraph: {
      fontSize: '1.1rem',
      color: '#666',
      marginBottom: '30px',
    },
    spinner: {
      width: '40px',
      height: '40px',
      border: '4px solid #eee',
      borderTop: '4px solid #007bff',
      borderRadius: '50%',
      animation: 'spin 1.1s linear infinite',
    },
    // keyframes not supported directly in inline style, inject via <style>
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.icon}>🚧</div>
      <h1 style={styles.heading}>Page Under Construction</h1>
      <p style={styles.paragraph}>
        We’re working hard to bring this page to life. Stay tuned!
      </p>
      <div style={styles.spinner}></div>

      {/* Spinner animation style */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default PageUnderDevelopment;
